module.exports = __webpack_public_path__ + "media/images/lb/999-b7ec29afb48a8f2dfd48256a6f0b3783.svg";